import storeAction from "../lib/const/storeAction";

/**
 * Variable naming convention for action function argument:
 * 1. dataHash for objects
 * 2. values for arrays
 * 3. value for single strings/numbers/booleans
 * @param {object} dependencyHash the object that contains app dependencies
 */
function mutationsConstructor(dependencyHash) {
  const mutations = {};

  mutations[storeAction.SET_SESSION_USER] = (state, dataHash) => {
    state.sessionUser = dataHash;
  };

  return mutations;
}

export default mutationsConstructor;
